module.exports = __webpack_public_path__ + "static/media/PaymentRecievedBIG.3ae28c36.svg";